import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '伏虎咒',
  content: [
    '白虎白虎，<br />听吾号令，',
    '速归山林，<br />勿再伤人，',
    '伏降白虎，<br />护我平安。'
  ],
  description: '伏虎咒为道家护身要咒，用于降服白虎煞，保身平安。',
  usage: [
    '出行时诵读可保一路平安',
    '农历每月十五日效果最佳',
    '夜间行路时诵读可避邪',
    '配合护身符使用效果更佳'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-teal-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-green-800 mb-8 hover:text-green-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-green-200 overflow-hidden">
            <div className="bg-gradient-to-r from-green-500 to-teal-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                降服白虎，护身平安
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: line }}></p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                  <h3 className="text-lg font-bold text-green-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                  <h3 className="text-lg font-bold text-green-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
